module.exports = "/_next/static/images/step1-c652231feea686233c23d062977df087.svg";